import React, { useState } from 'react';
import axiosInstance from '../../api/axiosInstance';

const endpoint = `${process.env.REACT_APP_API_URL}/api/googlesheet`;
// `${endpoint}${mode === 'import' ? '/import' : '/export'}`

function GoogleSheetUtil() {
  const [sheetLink, setSheetLink]         = useState('');
  const [tabOptions, setTabOptions]       = useState([]);
  const [selectedTab, setSelectedTab]     = useState('');
  const [collectionName, setCollectionName] = useState('');
  const [truncate, setTruncate]           = useState('true');
  const [mode, setMode]                   = useState('import'); // 'import' or 'export'
  const [status, setStatus]               = useState('');
  const [loading, setLoading]             = useState(false);
  const [tabsLoading, setTabsLoading]     = useState(false);
  const [tabsError, setTabsError]         = useState('');

  // Fetch sheet tabs
  const fetchTabs = async () => {
    setTabsError('');
    setTabOptions([]);
    setSelectedTab('');
    if (!sheetLink) {
      setTabsError('Enter a Google Sheet URL first.');
      return;
    }
    setTabsLoading(true);
    try {
      // const res = await fetch(`${endpoint}/tabs?${new URLSearchParams({ sheetLink })}`);
      // const json = await res.json();
      // if (!res.ok) throw new Error(json.error || 'Unknown error');
      const json = await axiosInstance.get(`${endpoint}/tabs?${new URLSearchParams({ sheetLink })}`);
      // console.log(JSON.stringify(json));
      if (mode === 'export') {
        setTabOptions(json.data.tabNames);
        setSelectedTab(json.data.tabNames[0] || '');
      } else {
        setTabOptions(['All', ...json.data.tabNames]);
        setSelectedTab('All');    // default to “All”
      }
    } catch (err) {
      setTabsError('Failed to load tabs: ' + err.message);
    } finally {
      setTabsLoading(false);
    }
  };

  // Handle import/export
  const handleSubmit = async e => {
    e.preventDefault();
    setStatus('');
    setLoading(true);

    const params = {
      sheetLink,
      tabName: selectedTab,
      collectionName
    };
    if (mode === 'import') {
      params.truncate = truncate;
    }

    try {
      if (mode === 'export') {
        const res = await axiosInstance.post(
          `${endpoint}/export`, new URLSearchParams(params),
          {
            // method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            // body: new URLSearchParams(params)
          }
        );
        // const text = await res.text();
        const text = res.data;
        setStatus(text);
      } else {
        let messages = [];
        const tabsToImport = selectedTab === 'All'
          ? tabOptions.filter(t => t !== 'All')
          : [selectedTab];

        let first = true;
        for (let tab of tabsToImport) {
          const body = new URLSearchParams({
            sheetLink,
            tabName: tab,
            collectionName,
            // only truncate on the very first sheet if in “All” mode
            truncate: first ? truncate : 'false'
          });
          const res = await axiosInstance.post(
            `${endpoint}/import`, body,
            {
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            });
          const txt = res.data;
          messages.push(`${tab}: ${txt}`);
          first = false;
        }
        setStatus(messages.join('\n'));
      }
      // setStatus(res.ok ? text : `Error: ${text}`);
    } catch (err) {
      setStatus('Network error: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 600, margin: '2rem auto', fontFamily: 'sans-serif' }}>
      <h1>Google Sheet ↔ MongoDB</h1>

      <form onSubmit={handleSubmit}>
        {/* Mode selector */}
        <fieldset style={{ marginBottom: '1rem', border: 'none', padding: 0 }}>
          <legend>Operation</legend>
          <label>
            <input
              type="radio" name="mode" value="import"
              checked={mode === 'import'}
              onChange={e => setMode(e.target.value)}
            /> Import
          </label>
          <label style={{ marginLeft: '1rem' }}>
            <input
              type="radio" name="mode" value="export"
              checked={mode === 'export'}
              onChange={e => setMode(e.target.value)}
            /> Export
          </label>
        </fieldset>

        {/* Sheet URL & Load Tabs */}
        <label>Google Sheet URL</label>
        <div style={{ display: 'flex', gap: '0.5rem', marginTop: '4px' }}>
          <input
            type="url"
            required
            placeholder="https://docs.google.com/spreadsheets/d/…"
            value={sheetLink}
            onChange={e => setSheetLink(e.target.value)}
            style={{ flex: 1, padding: '8px' }}
          />
          <button type="button"
                  onClick={fetchTabs}
                  disabled={tabsLoading}
                  style={{ padding: '8px 12px' }}>
            {tabsLoading ? 'Loading…' : 'Load tabs'}
          </button>
        </div>
        {tabsError && <div style={{ color: 'red' }}>{tabsError}</div>}

        {/* Tab dropdown */}
        {tabOptions.length > 0 && (
          <>
            <label style={{ marginTop: '1rem' }}>Choose Sheet Tab</label>
            <select
              required
              value={selectedTab}
              onChange={e => setSelectedTab(e.target.value)}
              style={{ width: '100%', padding: '8px', marginTop: '4px' }}
            >
              {tabOptions.map(name => (
                <option key={name} value={name}>{name}</option>
              ))}
            </select>
          </>
        )}

        {/* Collection name */}
        <label style={{ marginTop: '1rem' }}>Mongo Collection Name</label>
        <input
          type="text"
          // required
          placeholder="e.g. users, products"
          value={collectionName}
          onChange={e => setCollectionName(e.target.value)}
          style={{ width: '100%', padding: '8px', marginTop: '4px' }}
        />

        {/* Truncate — only show when importing */}
        {mode === 'import' && (
          <fieldset style={{ marginTop: '1rem', border: 'none', padding: 0 }}>
            <legend>Truncate before import?</legend>
            <label style={{ display: 'block', marginBottom: '0.5rem' }}>
              <input
                type="radio" name="truncate" value="true"
                checked={truncate === 'true'}
                onChange={e => setTruncate(e.target.value)}
              /> Yes
            </label>
            <label style={{ display: 'block' }}>
              <input
                type="radio" name="truncate" value="false"
                checked={truncate === 'false'}
                onChange={e => setTruncate(e.target.value)}
              /> No
            </label>
          </fieldset>
        )}

        {/* Submit */}
        <button
          type="submit"
          disabled={loading || !selectedTab || (!collectionName && mode === 'export') 
            || (selectedTab && selectedTab === 'All' && !collectionName && mode === 'import')
          }
          style={{ marginTop: '1.5rem', padding: '10px 20px', fontSize: '1rem' }}
        >
          {loading
            ? mode === 'import' ? 'Importing…' : 'Exporting…'
            : mode === 'import' ? 'Run Import' : 'Run Export'}
        </button>
      </form>

      {/* Status */}
      {status && (
        <div style={{ marginTop: '1.5rem', whiteSpace: 'pre-wrap' }}>
          {status}
        </div>
      )}
    </div>
  );
}

export default GoogleSheetUtil;

